module.exports = __webpack_public_path__ + "img/IconoLonas.3fdba46e.png";